/* Background color */

.bg-white {
  background-color: $color-bg;
}

.bg-primary {
  background-color: $color-primary;

  &-light{
    background-color: $color-primary-light;
  }
}

.bg-danger {
  background-color: $color-danger;

  &-light {
    background-color: $color-danger-light;
  }

  &-lighter {
    background-color: $color-danger-lighter;
  }
}

.bg-success {
  background-color: $color-success;

  &-light {
    background-color: $color-success-light;
  }
}


.bg-warning {
  background-color: $color-warning;

  &-light {
    background-color: $color-warning-light;
  }
}


.bg-gray {
  background-color:  $color-gray;

  &-lighter {
    background-color: $color-gray-lighter;
  }

  &-light {
    background-color: $color-gray-light;
  }

  &-dark {
    background-color:  $color-gray-dark;
  }
}

/* Borders */
.border-primary {
  border-color: $color-primary;

  &-light {
    border-color: $color-primary-light;
  }
}

.border-danger {
  border-color: $color-danger;

  &-light {
    border-color: $color-danger-light;
  }

  &-lighter {
    border-color: $color-danger-lighter;
  }
}

.border-success {
  border-color: $color-success-light;

  &-light {
    border-color: $color-success-light;
  }
}

.border-gray {
  border: 2px solid $color-gray;

  &-lighter {
    border: 2px solid $color-gray-lighter;
  }

  &-light {
    border: 2px solid $color-gray-light;
  }

  &-dark {
    border: 2px solid $color-gray-dark;
  }
}

/* Typography */
.text-gray {
  color:  $color-gray;

  &-dark {
    color:  $color-gray-dark;
  }
}

.text-danger {
  color: $color-danger-fg;
}

.text-primary {
  color: $color-primary-fg;
}

.text-success {
  color: $color-success-fg;
}

.text-bold {
  font-weight: bold;
}

.text-14 {
  font-family: $font-family-primary;
  font-size: 14px;
}

.text-13 {
  font-family: $font-family-primary;
  font-size: 13px;
}

.text-12 {
  font-family: $font-family-primary;
  font-size: 12px;
}

.text-11 {
  font-family: $font-family-primary;
  font-size: 11px;
}

.text-semibold {
  font-family: $font-family-semibold;
}

.not-selectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
}
